import { useAppSelector } from 'app/hooks';
import AlertModal from 'components/common/AlertModal';
import FeatureTitleBar from 'components/common/FeatureTitleBar';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import { Genre } from 'features/Genre/models/Genre';
import { selectIsEditMode } from 'features/common/editModeSlice';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import './Detail.scss';
import GenreFormDetail from './components/GenreFormDetail';
import service from './services';

interface EditModalInterface {
  id: string;
  show: boolean;
  handleCloseModalEdit: () => void;
  dataTable?: Genre[] | [];
  setDataTable?: (genres: Genre[]) => void;
}

function DetailModal({ id, show, handleCloseModalEdit, dataTable, setDataTable }: EditModalInterface) {
  const { t } = useTranslation();
  const [genre, setGenre] = useState<Genre>();
  const { showGlobalModal } = useGlobalModal();

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);

  useEffect(() => {
    const getGenre = async (id: string) => {
      await service
        .getGenre(id)
        .then((data) => {
          return data.data;
        })
        .then((data) => {
          setGenre(data);
        });
    };
    if (id) {
      getGenre(id).catch(() => {
        showGlobalModal &&
          showGlobalModal(() => (
            <AlertModal title={t('Genre.Validator.error')} message={t('Genre.Validator.500')}></AlertModal>
          ));
      });
    }
  }, [id, showGlobalModal, t]);

  return (
    <Modal show={show} onHide={handleCloseModalEdit} size="lg">
      <Modal.Header closeButton className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        <FeatureTitleBar title={t('Genre.Headers.title')}></FeatureTitleBar>
      </Modal.Header>
      <Modal.Body className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        {genre && (
          <GenreFormDetail
            genre={genre}
            id={id}
            handleCloseModalEdit={handleCloseModalEdit}
            dataTable={dataTable}
            setDataTable={setDataTable}
          ></GenreFormDetail>
        )}
      </Modal.Body>
    </Modal>
  );
}
export default DetailModal;
